import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';

const cssProps = [
    'font-family',
    'font-size',
    'font-weight',
    'font-size',
    'letter-spacing',
    'text-transform',
    'word-spacing',
    'text-indent',
    'box-sizing',
    'padding-left',
    'padding-right'
];

const hasComputedStyle = document.defaultView && document.defaultView.getComputedStyle;

const getContentWidth = function (el) {
    const backStyle = hasComputedStyle ? document.defaultView.getComputedStyle(el) : el.currentStyle;
    let width = parseFloat(backStyle['width']);
    if (backStyle['boxSizing'] === 'border-box') {
        width -= parseFloat(backStyle['paddingLeft'] || 0);
        width -= parseFloat(backStyle['paddingRight'] || 0);
        width -= parseFloat(backStyle['borderLeftWidth'] || 0);
        width -= parseFloat(backStyle['borderRightWidth'] || 0);
        if (width < 0) {
            width = 0;
        }
    }
    return width;
};

const AutoResizeTextField = Backbone.View.extend({

    tagName: 'input',

    events: {
        'change': '_onChange',
        'keypress': 'update',
        'keydown': 'update',
        'keyup': 'update',
        'input': 'update'
    },

    initialize: function (options) {
        this.options = _.defaults(options || {}, {
            type: AutoResizeTextField.Type.Text,
            value: ''
        });

        this.el.type = this.options.type;
        this.el.value = this.options.value;
        this._backBuffer = $('<span style="position:absolute;z-index:-1;left:0;top:-9999px;white-space:pre;"/>');
        this._backBuffer.hide().appendTo(document.body);
    },

    render: function () {
        const that = this;
        this.update(true);

        // In most cases render is called just before adding to the DOM
        setTimeout(function () {
            if (!that._backBuffer) return; // We may have just got destroyed...
            that.update(true);
        }, 0);

        return this;
    },

    syncCss: function () {
        const that = this;
        that._backBuffer.css(that.$el.css(cssProps));
        return that;
    },

    update: function (force) {
        let value = this.el.value;
        if (!value) {
            value = this.el.placeholder || "";
        }
        if (!force && value === this._backBuffer.text()) {
            return;
        }
        this.syncCss()._backBuffer.text(value).show();

        const newBackWidth = getContentWidth(this._backBuffer[0]);
        const currentContentWidth = getContentWidth(this.el);

        this._backBuffer.hide();
        if (currentContentWidth != newBackWidth) {
            this.$el.width(newBackWidth);

            if (getContentWidth(this.el) != currentContentWidth) {
                this.trigger('widthchange');
            }
        }

        return this;
    },

    value: function () {
        if (arguments.length) {
            this.el.value = arguments[0];
            this._onChange();
        } else {
            return this.el.value;
        }
    },

    _onChange: function () {
        this.trigger('change');
        this.update();
    },

    _onKeyPress: function () {
        this.update();
    },

    remove: function () {
        if (this._backBuffer) {
            this._backBuffer.remove();
            this._backBuffer = null;
        }

        AutoResizeTextField.__super__.remove.apply(this, arguments);
    }

});

/** @expose */
AutoResizeTextField.Type = {
    /** @expose */
    Text: 'text',

    /** @expose */
    Password: 'password',

    /** @expose */
    Search: 'search',

    /** @expose */
    Url: 'url',

    /** @expose */
    Tel: 'tel',

    /** @expose */
    Email: 'email'
};

export default AutoResizeTextField;
